import Vue from 'vue';
import WebIM from 'easemob-websdk';
import {
  websdkConf
} from '../package.json'

const onIMReady = new Promise(resolve => {
  const fun = () => {
    setTimeout(() => {
      /* eslint-disable no-undef */
      if (WebIM) {
        // FUCK IM 参数不明不白,大小写特别不明确
        websdkConf.apiUrl = `${window.location.protocol}//a1.easemob.com`;
        websdkConf.xmppUrl = `${window.location.protocol}//im-api-v2.easemob.com/ws`;
        websdkConf.apiURL = websdkConf.apiUrl;
        websdkConf.xmppURL = websdkConf.xmppUrl;
        websdkConf.url = websdkConf.xmppUrl;
        websdkConf.https = window.location.protocol.includes('https');
        websdkConf.useOwnUploadFun = false;



        WebIM.config = websdkConf;
        const webimDefault = WebIM.default || {};
        WebIM.message = WebIM.message || webimDefault.message;
        WebIM.utils = WebIM.utils || webimDefault.utils;
        WebIM.debug = WebIM.debug || webimDefault.debug || false;
        WebIM.statusCode = WebIM.statusCode || webimDefault.statusCode;
        WebIM.connection = WebIM.connection || webimDefault.connection;
        WebIM.version = WebIM.version;
        WebIM.doQuery = WebIM.doQuery || webimDefault.doQuery;
        console.log('websdkConf',websdkConf)
        WebIM.conn = new WebIM.connection(websdkConf);

        // window.WebIM = WebIM; // 开发环境与生产环境的结构不一致,通过此方法覆盖默认结构
        Vue.prototype.$WebIM = WebIM;
        resolve(WebIM);
      } else {
        fun();
      }
    }, 300);
  };
  fun();
});

Vue.prototype.$onIMReady = onIMReady;
